module.exports = __webpack_public_path__ + "img/tyvm-selkirk.3600d261.png";